import React from 'react';

import { FormProvider } from 'react-hook-form';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { UseReportSettingsModalLogic } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.logic';
import { UseReportSettingsModalProvider } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.provider';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/ReportSettingsForm.module.scss';
import { ReportAccessSettings } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings';
import { UpdateReportTags } from 'components/Dashboards/Reporting/ReportSettingsModal/components/UpdateReportTags/UpdateReportTags';

interface Props {
    logic: UseReportSettingsModalLogic['logic'];
    api: UseReportSettingsModalProvider['api'];
}

export const ReportSettingsForm = ({ logic, api }: Props) => {
    return (
        <FormProvider {...logic.methods}>
            <form onSubmit={logic.handleSubmit(logic.onSubmit)} className={classes.reportSettingsWrapper}>
                <div className={classes.section}>
                    <UpdateReportTags />
                </div>

                <div className={classes.section}>
                    <div className={classes.sectionTitleWithIcon}>
                        <MuiIcon icon={'lock'} fontSize={'2rem'} color={'var(--text-primary)'} type={'outlined'} />
                        <div>Control who can access this report</div>
                    </div>
                    <ReportAccessSettings api={api} />
                </div>
            </form>
        </FormProvider>
    );
};
